// extracted by mini-css-extract-plugin
module.exports = {"PageWithFilters":"styles_PageWithFilters__naoaz","hideOnSmallScreen":"styles_hideOnSmallScreen__oS0jn","hideOnLargeScreen":"styles_hideOnLargeScreen__18FDu"};